import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.l,

    backgroundColor: theme.palette.background.paper,
    borderRadius: 15,
    boxShadow: theme.shadows[5],

    [theme.breakpoints.down('tablet')]: {
      padding: `${SPACES.xxxxxl} ${SPACES.xxl} ${SPACES.xxl} ${SPACES.xxl}`,

      // minHeight: 508,
      width: 'calc(100% - 40px)',
    },

    [theme.breakpoints.up('tablet')]: {
      padding: SPACES.xxl,

      // minHeight: 560,
      width: '650px',
    },
  },
}))

export default useStyles
